// Defines the colors for the agent states

// This enum maps the agent state buckets to the state colors, new states can be added as needed
export enum AgentStateBucketColors {
    LoggedOut,
    Available,
    AvailableDialer,
    WorkingContacts,
    WorkingContactsDialer,
    Unavailable,
}

const agentStateColors: { [key in AgentStateBucketColors]: string } = { 
    [AgentStateBucketColors.LoggedOut]: "#ADADAD", // gray
    [AgentStateBucketColors.Available]: "#278A33", // green
    [AgentStateBucketColors.AvailableDialer]: "#DF6736", // orange
    [AgentStateBucketColors.WorkingContacts]: "#357AB9", // blue
    [AgentStateBucketColors.WorkingContactsDialer]: "#7D3CC8", // purple
    [AgentStateBucketColors.Unavailable]: "#BB2924", // red
    // Add new states as needed
};

// Get colors by agent state
export function getAgentStateColor(state: AgentStateBucketColors): string {
    return agentStateColors[state] || "#A8AFB9"; // Default color if state is not found / Valyrian Steel
}